import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

function Input({ className, type, icon, rightIcon, ...props }: InputProps) {
  return (
    <div className="relative">
      {icon && <div className="absolute left-4 top-0 h-full flex items-center text-[#169C9D]">{icon}</div>}
      <input
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-[#169C9D]/20 flex h-10 w-full min-w-0 rounded-md border border-gray-200 bg-white px-4 py-2 text-base shadow-sm transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          icon && "pl-12",
          rightIcon && "pr-12",
          "focus-visible:border-[#169C9D] focus-visible:ring-[#169C9D]/10 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      {rightIcon && <div className="absolute right-4 top-0 h-full flex items-center text-[#169C9D]">{rightIcon}</div>}
    </div>
  );
}

export { Input };
